const production = {
  url: {
    API_URL: 'https://www.podcastregister.com/backend'
  }
};

const dev = {
  url: {
    API_URL: 'http://localhost:4000'
  }
};

export const config = process.env.NODE_ENV === 'development' ? dev : production;
